module.exports = __webpack_public_path__ + "img/banner-reduced-inequalities.0df89194.png";